import DataRequest from '@get-bridge/learn-legacy-shared/dist/core/DataRequest'
import NotificationSchema from '../schemas/NotificationSchema'
import { assign } from 'lodash'

export default DataRequest({
  schema: NotificationSchema,
  url: '/api/learner/notifications',

  parse(normalize, payload) {
    return payload.notifications.map(normalize)
      .map(n => assign(n, {
        id: n.id.toString(),
        userId: n.userId.toString(),
        subject: n.subject || n.title,
      }))
  }
})



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/notifications/data_requests/getNotifications.js